import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectAccount } from "src/store/selectors";
import { UserGroup } from "src/types/users";

export const GroupRoute = ({
  component,
  groupsPermitted,
}: {
  component: ReactNode;
  groupsPermitted: UserGroup[];
}) => {
  const account = useSelector(selectAccount);

  const intersection = groupsPermitted.filter((group) => account.groups.includes(group));

  if (intersection.length === 0) {
    return <Navigate to="/overview" replace />;
  }

  return component;
};